import { app } from '../../api/app';
import { BrowserFourdApi } from '.';

export class App implements app.Api {
  constructor(private fourd: BrowserFourdApi) {}

  openApp(request: app.OpenAppRequest): void {
    this.fourd.call4Dv2('app.openApp', request);
  }

  openLegalGuide(request: app.OpenLegalGuideRequest): void {
    this.fourd.call4Dv2('app.openLegalGuide', request);
  }
}
